import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // should change this to log error to an error reporting service
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Error: something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
